import { render, staticRenderFns } from "./ContentBox.vue?vue&type=template&id=bd410066&scoped=true&"
import script from "./ContentBox.vue?vue&type=script&lang=js&"
export * from "./ContentBox.vue?vue&type=script&lang=js&"
import style0 from "@/sass/07_elements/content-box.scss?vue&type=style&index=0&id=bd410066&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd410066",
  null
  
)

export default component.exports